'use strict';

module.exports = /*@ngInject*/
function(
    ApiConfig,
    DateService,
    InterceptorService
) {
    return {
        /**
         * Add an item to the user's basket
         * @example
         *     OrdersHTTPService.addToBasket([{
         *         productId: 11223344555,
         *         skuId: 12345678
         *         quantity: 1,
         *         categoryId: 'DRESSES'
         *     }]);
         * @return {Object}         $q promise that will be fulfilled by the orders response
         */
        addToBasket: function(data) {
            return InterceptorService.post(ApiConfig.orders.items, data);
        },

        /**
         * Get the user's current cart count and cache it
         * for 10 seconds.
         * @return {Object}         $q promise that will be fulfilled by the orders response
         */
        getCartCount: function() {
            return InterceptorService.cachedGet(ApiConfig.orders.cartCount, '', {
                expiryTime: DateService.fromSecsToMS(5)
            });
        }
    };
};
